import { FiCheck } from 'react-icons/fi'

export default function Checkbox({ className = '', group = false, error = '', ...props }) {
    const errorId = props.id ? `${props.id}-group-error` : undefined

    if (group) {
        return (
            <div>
                <label className={`block mb-1 font-medium ${error ? 'text-danger' : 'text-black dark:text-white'}`}>
                    {props.label}
                </label>
                <div
                    className={className}
                    role="group"
                    aria-describedby={error && errorId ? errorId : undefined}
                >
                    {props.datas.map((data, key) => (
                        <Checkbox
                            key={key}
                            id={data.id}
                            name={data.id}
                            checked={props.value.includes(data.value)}
                            label={data.label}
                            message={data.message ?? ''}
                            onChange={() => {
                                var selectIds = [...props.value]
                                if (!selectIds.includes(data.value)) {
                                    selectIds.push(data.value)
                                } else {
                                    selectIds = selectIds.filter(g => g !== data.value)
                                }
                                props.onChange(selectIds)
                            }}
                            disabled={props.disabled ?? false}
                        />
                    ))}
                </div>
                {error && (
                    <p id={errorId} role="alert" className="text-sm text-danger">
                        {error}
                    </p>
                )}
            </div>
        )
    }
    return (
        <div className={className}>
            <label
                htmlFor={props.id}
                className={`flex select-none items-center ${!props.disabled ? 'cursor-pointer' : 'cursor-not-allowed'}`}
            >
                <div className="relative">
                    <input {...props} type="checkbox" className="sr-only peer" />
                    <div
                        className={`${props.label ? 'mr-2' : ''} flex h-5 w-5 items-center justify-center rounded peer-focus-visible:ring-2 peer-focus-visible:ring-primary peer-focus-visible:ring-offset-1 dark:peer-focus-visible:ring-secondary ${
                            props.checked && !props.disabled
                                ? `border-primary dark:border-secondary bg-gray dark:bg-transparent`
                                : ''
                        } ${props.disabled ? 'bg-whiter dark:bg-black opacity-50' : 'border'}`}
                    >
                        <span
                            className={`opacity-0 ${
                                props.checked ? `!opacity-100 ${!props.disabled ? 'text-primary dark:text-secondary' : ''}` : ''
                            } `}
                        >
                            <FiCheck size={14} aria-hidden="true" />
                        </span>
                    </div>
                </div>
                {props.label}
            </label>
        </div>
    )
}
